import {Module} from "../common/Module";
import {Nullable} from "../common/Nullable";
import {AuthenticatedUser} from "../users/AuthenticatedUser";
import {isPrivileged} from "../../config/Privileges";
import {ReportingAreaType} from "./ReportingAreaType";

export const ProjectSolvencyReportModule: Module = {
    identifier: "solvency_projection",
    isPrivileged(
        authUser: Nullable<AuthenticatedUser>,
        privilege: string, privilegeIdentifier: string | undefined
    ): boolean {
        return isPrivileged(
            authUser,
            ReportingAreaType, 
            ProjectSolvencyReportModule.identifier,
            privilege
        );
    }
};